module.exports = "<hybse-admin-adduser [userType]=\"'Issuer'\"></hybse-admin-adduser>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/users/issuers/add-user/add-user.component.html
// module id = ../../../../../src/app/components/pages/users/issuers/add-user/add-user.component.html
// module chunks = main